class VirtualCalendar {
  constructor() {
    this.rootEl = document.querySelector('.js-create-virtual-calendar');
    if (!this.rootEl) {
      throw new Error('Root calendar links holder not found.');
    }

    this.ICSLink = this.rootEl.querySelector('.js-ics');
    this.gcalLink = this.rootEl.querySelector('.js-gcal');

    if (!this.ICSLink && !this.gcalLink) {
      throw new Error('No links for creating calendar.');
    }

    this.data = {
      title: this.rootEl.dataset.title,
      description: this.rootEl.dataset.description,
      location: this.rootEl.dataset.location,
      url: this.rootEl.dataset.url,
      start: this.rootEl.dataset.start,
      end: this.rootEl.dataset.end,
      isAllDay: this.rootEl.dataset.allday === 'true'
    };

    this.init();
  }

  init() {
    if (this.ICSLink) {
      this.ICSLink.addEventListener('click', () => this.downloadICS());
    }
    if (this.gcalLink) {
      this.gcalLink.addEventListener('click', () => this.openGCal());
    }
  }

  sanitizeICSValue = (str) => str
      .replace(/\\/g, '\\\\')
      .replace(/;/g, '\\;')
      .replace(/,/g, '\\,')
      .replace(/\n/g, '\\n');

  // RFC 5545 §3.6.5: every TZID referenced by DTSTART/DTEND must have a
  // matching VTIMEZONE component in the file. Hardcoded for America/New_York
  // to match the data-timezone attribute in share-tools-overlay.twig.
  VTIMEZONE = [
    'BEGIN:VTIMEZONE',
    'TZID:America/New_York',
    'BEGIN:DAYLIGHT',
    'TZOFFSETFROM:-0500',
    'TZOFFSETTO:-0400',
    'TZNAME:EDT',
    'DTSTART:19700308T020000',
    'RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU',
    'END:DAYLIGHT',
    'BEGIN:STANDARD',
    'TZOFFSETFROM:-0400',
    'TZOFFSETTO:-0500',
    'TZNAME:EST',
    'DTSTART:19701101T020000',
    'RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU',
    'END:STANDARD',
    'END:VTIMEZONE'
  ];

  downloadICS() {
    const tz = this.rootEl.dataset.timezone;

    const start = this.data.isAllDay
      ? `DTSTART;VALUE=DATE:${this.data.start.slice(0, 8)}`
      : `DTSTART;TZID=${tz}:${this.data.start}`;
    const end = this.data.isAllDay
      ? `DTEND;VALUE=DATE:${this.data.end.slice(0, 8)}`
      : `DTEND;TZID=${tz}:${this.data.end}`;

    const icsContent = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Pratt//Events//EN',
      ...(this.data.isAllDay ? [] : this.VTIMEZONE),
      'BEGIN:VEVENT',
      start,
      end,
      `SUMMARY:${this.data.title}`,
      `DESCRIPTION:${this.sanitizeICSValue(this.data.description)}\\nMore info: ${this.data.url}`,
      `URL:${this.data.url}`,
      `LOCATION:${this.data.location}`,
      'END:VEVENT',
      'END:VCALENDAR'
    ].join('\r\n');

    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${this.data.title}.ics`;
    link.click();
    URL.revokeObjectURL(link.href);
  }

  openGCal() {
    const dates = this.data.isAllDay
      ? `${this.data.start.slice(0, 8)}/${this.data.end.slice(0, 8)}`
      : `${this.data.start}/${this.data.end}`;

    const params = new URLSearchParams({
      action: 'TEMPLATE',
      text: this.data.title,
      dates: dates,
      ctz: this.rootEl.dataset.timezone,
      details: `${this.data.description}\n\nMore info: ${this.data.url}`,
      location: this.data.location
    });

    window.open(`https://calendar.google.com/calendar/render?${params}`, '_blank');
  }
}

export default VirtualCalendar;
